// functionStore.js
let loginSuccessFunction: () => void;

export const setLoginSuccessFunction = (func: () => void) => {
	loginSuccessFunction = func;
};

export const getLoginSuccessFunction = () => loginSuccessFunction;
